import { render, staticRenderFns } from "./archiving.vue?vue&type=template&id=110a25f8&scoped=true"
import script from "./archiving.vue?vue&type=script&lang=js"
export * from "./archiving.vue?vue&type=script&lang=js"
import style0 from "./archiving.vue?vue&type=style&index=0&id=110a25f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110a25f8",
  null
  
)

export default component.exports